export const extractStringFromCellValue = (cellValue) => {
  if (!cellValue) return '';
  
  if (typeof cellValue === 'string') return cellValue;
  
  // If it's a rich text object (DraftJS or Lexical), try to extract plain text
  if (cellValue.blocks && Array.isArray(cellValue.blocks)) {
    // DraftJS format
    return cellValue.blocks.map(block => block.text).join(' ');
  }
  
  if (cellValue.root && cellValue.root.children) {
    // Lexical format - simplified extraction
    return JSON.stringify(cellValue).replace(/[{}"\[\]]/g, ' ').trim();
  }
  
  // For any other object, try to stringify and clean
  if (typeof cellValue === 'object') {
    return String(cellValue).trim();
  }
  
  return String(cellValue);
};
